export default __webpack_public_path__ + "static/media/second-block-coins.f6d7060a.png";